import React, { useLayoutEffect, useRef } from "react";

export const pageStyle = {};

export const basePanelStyle = {
  border: "1px solid #e5e7eb",
  borderRadius: 16,
  background: "#ffffff",
  padding: 14,
  scrollMarginTop: 135,
  boxShadow: "0 8px 22px rgba(15, 23, 42, 0.05)",
};

export const sectionTitleStyle = {
  fontSize: 17,
  fontWeight: 800,
  marginBottom: 0,
};

export const buttonStyle = {
  border: "1px solid #cbd5e1",
  borderRadius: 10,
  minHeight: 44,
  padding: "0 16px",
  background: "#fff",
  cursor: "pointer",
  textDecoration: "none",
  fontSize: 14,
  fontWeight: 700,
  fontFamily: "inherit",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  lineHeight: 1,
  whiteSpace: "nowrap",
  appearance: "none",
  WebkitAppearance: "none",
};

export const primaryButtonStyle = {
  ...buttonStyle,
  background: "#0f172a",
  color: "#fff",
  borderColor: "#0f172a",
};

export const createButtonStyle = {
  ...buttonStyle,
  background: "#166534",
  color: "#fff",
  borderColor: "#166534",
};

export const backButtonStyle = {
  ...buttonStyle,
  background: "#7c3aed",
  color: "#fff",
  borderColor: "#7c3aed",
};

export const dangerButtonStyle = {
  ...buttonStyle,
  color: "#b91c1c",
  borderColor: "#fecaca",
  background: "#fff",
};

export const jumpButtonStyle = {
  ...buttonStyle,
  minHeight: 40,
  padding: "0 12px",
  fontSize: 13,
};

export const inputStyle = {
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  border: "1px solid #cbd5e1",
  borderRadius: 8,
  padding: "6px 8px",
  fontSize: 13,
  height: 38,
  background: "#fff",
  boxSizing: "border-box",
};

export const requiredInputStyle = {
  ...inputStyle,
  border: "2px solid #ef4444",
  background: "#fef2f2",
};

export const textareaStyle = {
  ...inputStyle,
  minHeight: 56,
  height: "auto",
  resize: "none",
  overflow: "hidden",
};

export const labelStyle = {
  display: "grid",
  gap: 3,
  fontSize: 12,
  color: "#475569",
  minWidth: 0,
  maxWidth: "100%",
};

export const requiredLabelStyle = {
  ...labelStyle,
  color: "#dc2626",
};

export const sectionHeaderRowStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 10,
  flexWrap: "wrap",
  marginBottom: 10,
};

export const toggleButtonStyle = {
  ...buttonStyle,
  padding: "6px 10px",
  fontSize: 12,
};

export const pillStyle = {
  display: "inline-flex",
  alignItems: "center",
  borderRadius: 999,
  padding: "4px 10px",
  fontSize: 12,
  fontWeight: 700,
};

export const sectionBadgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 20,
  height: 20,
  padding: "0 6px",
  marginLeft: 8,
  borderRadius: 999,
  background: "#ef4444",
  color: "#fff",
  fontSize: 11,
  fontWeight: 800,
  lineHeight: 1,
};

export const rhythmOptions = [
  "NSR",
  "Sinus Tach",
  "Sinus Brady",
  "A-Fib",
  "A-Flutter",
  "SVT",
  "VT",
  "VF",
  "PEA",
  "Asystole",
  "Other",
];

export const painOptions = ["", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];

export const gcsEyeOptions = [
  { value: "", label: "Select" },
  { value: "4", label: "4 - Spontaneous" },
  { value: "3", label: "3 - To voice" },
  { value: "2", label: "2 - To pain" },
  { value: "1", label: "1 - None" },
];

export const gcsVerbalOptions = [
  { value: "", label: "Select" },
  { value: "5", label: "5 - Oriented" },
  { value: "4", label: "4 - Confused" },
  { value: "3", label: "3 - Inappropriate words" },
  { value: "2", label: "2 - Incomprehensible sounds" },
  { value: "1", label: "1 - None" },
];

export const gcsMotorOptions = [
  { value: "", label: "Select" },
  { value: "6", label: "6 - Obeys commands" },
  { value: "5", label: "5 - Localizes pain" },
  { value: "4", label: "4 - Withdraws from pain" },
  { value: "3", label: "3 - Flexion to pain" },
  { value: "2", label: "2 - Extension to pain" },
  { value: "1", label: "1 - None" },
];

export const sectionThemes = {
  patientInfo: {
    border: "#bfdbfe",
    accent: "#2563eb",
    bg: "linear-gradient(180deg, #eff6ff 0%, #f8fbff 100%)",
    text: "#1d4ed8",
  },
  summary: {
    border: "#cbd5e1",
    accent: "#475569",
    bg: "linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)",
    text: "#334155",
  },
  vitals: {
    border: "#99f6e4",
    accent: "#0f766e",
    bg: "linear-gradient(180deg, #ecfeff 0%, #f8fffe 100%)",
    text: "#115e59",
  },
  documents: {
    border: "#fde68a",
    accent: "#d97706",
    bg: "linear-gradient(180deg, #fffbeb 0%, #fffdf5 100%)",
    text: "#b45309",
  },
  medical: {
    border: "#bbf7d0",
    accent: "#16a34a",
    bg: "linear-gradient(180deg, #f0fdf4 0%, #fbfffc 100%)",
    text: "#15803d",
  },
  incident: {
    border: "#fdba74",
    accent: "#ea580c",
    bg: "linear-gradient(180deg, #fff7ed 0%, #fffaf5 100%)",
    text: "#c2410c",
  },
  signatures: {
    border: "#ddd6fe",
    accent: "#7c3aed",
    bg: "linear-gradient(180deg, #f5f3ff 0%, #faf8ff 100%)",
    text: "#6d28d9",
  },
  history: {
    border: "#d1d5db",
    accent: "#6b7280",
    bg: "linear-gradient(180deg, #f9fafb 0%, #ffffff 100%)",
    text: "#4b5563",
  },
};

export const blankMedicalForm = {
  hpiComplaint: "",
  assessment: "",
  planTreatmentDisposition: "",
  treatments: [],
  bodyPartInjured: "",
  firstAidGiven: false,
  disposition: "",
};

export const blankEncounterForm = {
  status: "open",
  arrivalDate: "",
  arrivalTime: "",
  chiefComplaint: "",
  bed: "",
  seenAt: "HQ",
  source: "",
  providerName: "",
  reportCompletedBy: "",
  notes: "",
};

export function AutoTextarea({ value, onChange, style, ...props }) {
  const textareaRef = useRef(null);

  const resize = () => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  };

  useLayoutEffect(() => {
    resize();
  }, [value]);

  return (
    <textarea
      {...props}
      ref={textareaRef}
      value={value}
      onChange={(e) => {
        onChange(e);
        requestAnimationFrame(resize);
      }}
      style={{
        ...textareaStyle,
        ...style,
      }}
    />
  );
}

export function InfoRow({ label, value }) {
  return (
    <div>
      <div style={{ fontSize: 11, color: "#64748b", marginBottom: 3 }}>{label}</div>
      <div style={{ fontWeight: 700 }}>{value || "—"}</div>
    </div>
  );
}

export function SectionCard({
  title,
  sectionKey,
  expandedSections,
  toggleSection,
  children,
  sectionRef,
  extraHeaderContent = null,
  activeSection,
  errorCount = 0,
}) {
  const isExpanded = expandedSections[sectionKey];
  const theme = sectionThemes[sectionKey] || sectionThemes.summary;
  const isActive = activeSection === sectionKey;

  return (
    <div
      ref={sectionRef}
      data-section-key={sectionKey}
      style={{
        ...basePanelStyle,
        border: `1px solid ${theme.border}`,
        borderTop: `5px solid ${theme.accent}`,
        boxShadow: isActive
          ? `0 0 0 2px ${theme.border}, 0 12px 24px rgba(15, 23, 42, 0.07)`
          : basePanelStyle.boxShadow,
        transition: "box-shadow 0.2s ease, transform 0.2s ease",
      }}
    >
      <div
        style={{
          ...sectionHeaderRowStyle,
          margin: "-14px -14px 12px -14px",
          padding: "10px 14px",
          background: theme.bg,
          borderTopLeftRadius: 11,
          borderTopRightRadius: 11,
          borderBottom: `1px solid ${theme.border}`,
        }}
      >
        <div
          style={{
            ...sectionTitleStyle,
            color: theme.text,
            display: "flex",
            alignItems: "center",
          }}
        >
          {title}
          {errorCount > 0 && <span style={sectionBadgeStyle}>{errorCount}</span>}
        </div>

        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          {extraHeaderContent}
          <button
            type="button"
            style={{
              ...toggleButtonStyle,
              borderColor: theme.border,
              color: theme.text,
              background: "#fff",
            }}
            onClick={() => toggleSection(sectionKey)}
          >
            {isExpanded ? "Hide" : "Show"}
          </button>
        </div>
      </div>

      {isExpanded ? children : <div style={{ color: "#64748b", fontSize: 13 }}>Section collapsed.</div>}
    </div>
  );
}

export function digitsOnly(value = "") {
  return String(value || "").replace(/\D/g, "");
}

export function formatPhone(value = "") {
  const digits = digitsOnly(value).slice(0, 10);
  if (!digits) return "";
  if (digits.length < 4) return `(${digits}`;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

export function parseBp(bp = "") {
  const [systolic = "", diastolic = ""] = String(bp).split("/");
  return {
    systolic: digitsOnly(systolic).slice(0, 3),
    diastolic: digitsOnly(diastolic).slice(0, 3),
  };
}

export function parseTemp(temp = "") {
  const raw = String(temp || "").trim();
  if (!raw) return { tempValue: "", tempUnit: "F" };
  const unit = /c$/i.test(raw) ? "C" : "F";
  const tempValue = raw.replace(/[^\d.]/g, "");
  return { tempValue, tempUnit: unit };
}

export function getGcsTotal(eye, verbal, motor) {
  const total = Number(eye || 0) + Number(verbal || 0) + Number(motor || 0);
  if (!eye && !verbal && !motor) return "";
  return String(total);
}

export function buildBpString(systolic, diastolic) {
  if (!systolic && !diastolic) return "";
  if (systolic && diastolic) return `${systolic}/${diastolic}`;
  return systolic || diastolic || "";
}

export function buildTempString(tempValue, tempUnit) {
  if (!tempValue) return "";
  return `${tempValue}°${tempUnit || "F"}`;
}

export function getPatientAddressDisplay(patient) {
  const street = patient?.streetAddress || "";
  const city = patient?.city || "";
  const state = patient?.state || "";
  const zip = patient?.zip || "";

  const cityState = [city, state].filter(Boolean).join(", ");
  const line2 = [cityState, zip].filter(Boolean).join(" ");
  const combined = [street, line2].filter(Boolean).join(", ");
  return combined || patient?.address || "—";
}

export function getDisplayValueWithNone(textValue, noneFlag) {
  if (noneFlag) return "None";
  return textValue || "—";
}

export function getEmployeeDisplayName(employee = {}) {
  const name =
    employee.displayName ||
    employee.fullName ||
    [employee.firstName, employee.lastName].filter(Boolean).join(" ") ||
    employee.name ||
    employee.email ||
    "";

  const level =
    employee.level ||
    employee.position ||
    employee.roleLabel ||
    employee.providerLevel ||
    employee.credential ||
    employee.title ||
    "";

  return level ? `${name}, ${level}` : name;
}

export function isProviderEmployee(employee = {}) {
  const haystack = [
    employee.level,
    employee.position,
    employee.roleLabel,
    employee.providerLevel,
    employee.credential,
    employee.title,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return (
    haystack.includes("physician") ||
    haystack.includes("aprn") ||
    haystack.includes("pa") ||
    haystack.includes("provider")
  );
}

export function compactHistoryStatus(status = "") {
  if (!status) return "—";
  return String(status)
    .replace(/([A-Z])/g, " $1")
    .replace(/\s+/g, " ")
    .trim();
}

export function getStatusPillStyle(status = "") {
  const normalized = String(status || "").toLowerCase();

  if (normalized === "open" || normalized === "under care") {
    return {
      ...pillStyle,
      background: "#dcfce7",
      color: "#166534",
    };
  }

  if (normalized === "awaiting transport") {
    return {
      ...pillStyle,
      background: "#fef3c7",
      color: "#92400e",
    };
  }

  if (normalized === "sent to hospital" || normalized === "senttohospital") {
    return {
      ...pillStyle,
      background: "#fee2e2",
      color: "#b91c1c",
    };
  }

  if (normalized === "closed" || normalized === "discharged") {
    return {
      ...pillStyle,
      background: "#e2e8f0",
      color: "#475569",
    };
  }

  return {
    ...pillStyle,
    background: "#f1f5f9",
    color: "#475569",
  };
}

export function isEmpty(val) {
  return val === undefined || val === null || String(val).trim() === "";
}

export function getFieldStyle(value, isRequired = false) {
  if (!isRequired) return inputStyle;
  return isEmpty(value) ? requiredInputStyle : inputStyle;
}

export function getLabelStyle(value, isRequired = false) {
  if (!isRequired) return labelStyle;
  return isEmpty(value) ? requiredLabelStyle : labelStyle;
}

export function hasRequiredVitals(vitals) {
  if (!Array.isArray(vitals)) return false;

  return vitals.some(
    (v) =>
      !isEmpty(v.systolic) &&
      !isEmpty(v.diastolic) &&
      !isEmpty(v.pulse) &&
      !isEmpty(v.resp)
  );
}